export const validateDgid = async (dgid: string): Promise<string | undefined> => !dgid
    ? "Account Number cannot be Blank."
    : undefined;
